<template>
  <div class="box13">
    <pageTitle title="真实学员评价" />

    <div
      class="seamless-warp"
      ref="seamlessWrap"
      @mouseenter="stop"
      @mouseleave="gonext"
    >
      <div class="content-box" ref="contentBox">
        <div class="content2" ref="content2">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            ref="item"
          >
            <img
              @click="showImg(index)"
              :src="
                require(`../../../assets/coursePage/architect/box13/${
                  index + 1
                }@3x.png`)
              "
              alt
            />
          </div>
        </div>
        <div class="content2 content3" ref="content3">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            ref="item"
          >
            <img
              :src="
                require(`../../../assets/coursePage/architect/box13/${
                  index + 1
                }@3x.png`)
              "
              alt
            />
          </div>
        </div>
      </div>
    </div>

    <previewImage
      ref="previewImage"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      :list="list"
      @close="close"
      type="img"
      :targetImg="list[this.clickedIndex].img"
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import previewImage from "../common/previewImage.vue";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    previewImage,
    pageTitle,
  },
  mounted() {
    this.timer = setInterval(this.Marquee, 15);
  },
  data() {
    let that = this;
    return {
      timer: null,
      swiperOption: {
        // loop: true, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 18,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box16",
        },
        on: {
          click(e) {
            if (e.target.nodeName == "IMG") {
              that.clickedIndex = this.clickedIndex;

              that.$refs.previewImage.changeCur();
              that.isPreview = true;
            }
          },
        },
      },
      clickedIndex: 0,
      isPreview: false,
      imageUrl: "",
      list: [
        {
          img: require("../../../assets/coursePage/architect/box13/1@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/2@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/3@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/4@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/5@3x.png"),
        },

        {
          img: require("../../../assets/coursePage/architect/box13/6@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/7@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/8@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/9@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/10@3x.png"),
        },

        {
          img: require("../../../assets/coursePage/architect/box13/11@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/12@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/13@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/14@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/15@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/16@3x.png"),
        },
        {
          img: require("../../../assets/coursePage/architect/box13/17@3x.png"),
        },
      ],
    };
  },
  methods: {
    close() {
      this.isPreview = false;
      this.imageUrl = "";
    },
    showImg(index) {
      console.log(index);
      this.clickedIndex = index;
      this.cur = index;
      this.isPreview = true;
    },
    Marquee() {
      if (this.num >= -this.$refs.content2.offsetWidth) {
        this.num -= 0.5;
        this.$refs.contentBox.style.transform = `translateX(${this.num}px)`;
      } else {
        this.num = 0;
      }
    },
    stop() {
      clearInterval(this.timer);
    },
    gonext() {
      this.timer = setInterval(this.Marquee, 15);
    },
  },
};
</script>

<style lang="less" scoped>
.box13 {
  padding: 80px 0px 88px;
  width: 100%;
  overflow: hidden;
  .seamless-warp {
    width: 1200px;
    height: 322px;
    margin: 48px auto 0;
    overflow: hidden;
    position: relative;
    .content-box {
      display: flex;
    }
    .content2 {
      display: flex;
      margin: 0 auto;
      position: relative;
      .item {
        height: 322px;
        overflow: hidden;
        position: relative;
        img {
          border-radius: 8px;
          margin-right: 32px;
          height: 322px;
          border: 4px solid #ffffff;
          border-radius: 20px;
          object-fit: contain;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>
